export function AssertLogin(shouldBe = true) {
	return function decorator(target, propertyKey, descriptor) {
		const originalMethod = descriptor.value;

		descriptor.value = function (context, ...args) {
			if (!context.rootGetters) throw new Error('Error, this decorator can only be used on store actions!');

			if (context.rootGetters['api/authenticated'] !== shouldBe) {
				return Promise.reject(new Error(`${shouldBe ? 'not_' : ''}logged_in`));
			}

			return originalMethod.apply(this, [context, ...args]);
		};

		return descriptor;
	};
}

export function AssertHomey(shouldBe = true) {
	return function decorator(target, propertyKey, descriptor) {
		const originalMethod = descriptor.value;

		const result = {
			@AssertLogin()
			async decoratedFn(context, ...args) {
				if (!context.rootGetters) throw new Error('Error, this decorator can only be used on store actions!');

				if (Boolean(context.rootGetters['api/homey/selectedId']) !== shouldBe) {
					return Promise.reject(new Error(`${shouldBe ? 'no_' : ''}homey_selected`));
				} else if (!context.rootGetters['api/homey/api']) {
					await new Promise((resolve, reject) => {
						let count = 0;
						const interval = setInterval(() => {
							if (context.rootGetters['api/homey/api']) {
								resolve();
							} else if (count > 20) {
								clearInterval(interval);
								throw new Error('Error, could not get Homey api');
							}
							count++;
						}, 1000);
					});
				}

				const homeyAPI = context.rootGetters['api/homey/api'];
				return originalMethod.apply(this, [Object.assign({}, context, { homeyAPI }), ...args]);
			}
		};

		descriptor.value = result.decoratedFn;
		return descriptor;
	}
}

export function RequireUser() {
	return function decorator(target, propertyKey, descriptor) {
		const originalMethod = descriptor.value;

		const result = {
			@AssertLogin()
			decoratedFn(context, ...args) {
				if (!context.rootGetters) throw new Error('Error, this decorator can only be used on store actions!');

				if (context.rootGetters['api/user']) {
					return originalMethod.apply(this, [context, ...args]);
				}

				return context.dispatch('api/getUser', null, { root: true })
					.then(() => originalMethod.apply(this, [context, ...args]));
			}
		};

		descriptor.value = result.decoratedFn;
		return descriptor;
	}
}